<template>
    <div>
        <div class="choiceinput" :style="disabled?'background: #E4E7ED;':''">
               <div class="choiceInput_content" >
                    <div class="add" v-if="!disabled" @click="openChoice"><span>+</span> <span>添加</span></div>
                    <div v-for="(item, index) in selectList" :key="index" class="selectItem" >
                        <el-tag type="info" disable-transitions  :key="item" :closable='!disable' @close="removeData(index, selectList)"> {{ item.realName}}</el-tag>
                    </div>
               </div>
               <div v-if="option.model=='people'" class="limitInfo">
                   <span >{{this.selectList.length}}/{{this.option.limit}}</span>

               </div>
               <div  v-if="option.model=='singlePeople'" class="singlePeople">

                   <span>{{this.selectList.length}}/{{1}}</span>

               </div>
               <div v-if="option.model=='unlimitPeople'" class="limitInfo">

                   <span >{{this.selectList.length||''}}</span>
               </div>

        </div>
        <choicePeople :option="option" v-if="visible" :visible.sync='visible' @getSelectList="getSelectList"></choicePeople>
    </div>
</template>

<script>
 import choicePeople from "./index.vue"
//import choicePeople from "./choicePeopleConsortium.vue"
export default {
    components:{
        choicePeople
    },
    props:{
        visible:{
            default:false
        },
        disabled:{
            default:false
        },
        option:{},
        value:{},

    },
    data(){
        return {

            selectList :[

            ]
        }

    },
    created(){
        this.selectList = this.option.selectList;
    },
    methods:{
        updateData(){
            this.selectList = this.option.selectList;
        },
        openChoice(){
        //     this.option.selectList = this.selectList
        //     this.option.projectId = '1337635452094083074'
        //     this.option.model = "unlimitPeople"
        //     this.option.limit = 3
        //     this.option.prohibitList=[

        // ],
         this.option.selectList = this.deepClone(this.selectList)
        console.log("mosi",this.option)
            this.visible = true
        },
    //      option1: {
    //     projectId: '1466302606614343681',
    //     variable: '',
    //     searchType: '',
    //     deptId: '',
    //     model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
    //     selectList: [], //已选的集合
    //     prohibitList: [], //禁止选的集合
    //     limit: 3,
    //   },
        getSelectList(list){
            this.selectList = list
            if(this.option.model=='people'){
                if(this.selectList.length>0){
                    this.$emit('getPeople',this.selectList)
                    // this.value = this.selectList[0]
                }

            }
            if(this.option.model=='singlePeople'){
                if(this.selectList.length>0){
                    this.$emit('getPeople',this.selectList[0])
                    // this.value = this.selectList[0]
                }

            }
            if(this.option.model=='unlimitPeople'){
                if(this.selectList.length>0){
                    this.$emit('getPeople',this.selectList)
                    // this.value = this.selectList[0]
                }

            }
        },
        removeData(index,data){
            data.splice(index,1)
            if(this.option.model=='singlePeople'){

                    this.$emit('getPeople',{})
                    // this.value = this.selectList[0]


            }else{
                this.$emit('getPeople',data)
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.singlePeople{
    position: absolute;
    right: 8px;
    top: 0;
}
.limitInfo{
    color: #C0C4CC;
    font-size: 14px;
    text-align: right;
}
.choiceinput{
    width: 100%;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
     min-height: 32px;
     padding: 0px 20px 0 14px;
     padding-top: 3px;
     box-sizing: border-box;
     position: relative;
}
.choiceinput_content{
    width: 100%;
   display: flex;

}
.selectItem{
    display: inline-block;
    margin-right: 8px;
     height:24px;
     margin-bottom: 3px;
     .el-tag{
         height:24px;
         line-height: 24px;
     }
}
    .add{
        border:1px dashed #409EFF;
        height:24px;
        width:60px;
        font-size: 14px;
        color: #409EFF;
        display: inline-block;
        margin-right: 8px;
        border-radius: 4px;
        padding: 0px 7px;
        box-sizing: border-box;
        line-height: 24px;
        margin-bottom: 3px;
        cursor:pointer;
    }
</style>
